export const SNACKBAR_ITEM = 'snackbar-item';
